var Sticky = require('sticky-js');
var screenWidth = jQuery(window).width();
if (screenWidth >= 800) {
  var referenceSticky = new Sticky('.dd-reference-info__wrapper');
}


var Sticky = require('sticky-js');
var screenWidth = jQuery(window).width();
if (screenWidth >= 800) {
  var referenceSticky = new Sticky('.js-sticky');
}




